import {
  IInterestFormPage,
} from '@src/Api/Umbraco/Hooks/useSignupForm';
import React, {FC} from 'react';
import {FieldValues} from 'react-hook-form';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
import SignupInterestFormContent from './components/SignupInterestFormContent';
import { SignUpStepsEnum } from '../../enums/signupStepsEnum';

export interface SignUpInterestProps {
  onSubmit: (formData: any) => Promise<boolean>;
  registerStep: {
    page: SignUpStepsEnum;
    step: number;
  };
  initialValues: FieldValues;
  additionalSteps: IInterestFormPage[];
}

const SignUpInterest: FC<SignUpInterestProps> = ({
  onSubmit,
  registerStep,
  initialValues,
  additionalSteps,
}) => {
  const {isMobile} = useBreakpoint();
  const {t} = useTranslation('auth');
  const {title, subtitle, form} = additionalSteps[registerStep.step] || {};

  return form ? (
    <SignupInterestFormContent
      form={form}
      t={t}
      isMobile={isMobile}
      title={title}
      subtitle={subtitle}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  ) : null;
};

export default React.memo(SignUpInterest);
